export const PERMISSIONS = {
  classStudentsView: "classStudentsView",
  studentsView: "studentsView",
  classStudentCreate: "classStudentCreate",
  studentCreate: "studentCreate",
  classStudentEdit: "classStudentEdit",
  studentEdit: "studentEdit",
  classStudentDelete: "classStudentDelete",
  studentDelete: "studentDelete",
  studentImport: "studentImport",
  studentExport: "studentExport",
  staffsView: "staffsView",
  staffCreate: "staffCreate",
  staffEdit: "staffEdit",
  staffDelete: "staffDelete",
  classFeeRecord: "classFeeRecord",
  feeRecord: "feeRecord",
  feeReceiptView: "feeReceiptView",
  classStudentAttendanceMark: "classStudentAttendanceMark",
  studentAttendanceMark: "studentAttendanceMark",
  staffAttendanceMark: "staffAttendanceMark",
  classStudentAttendanceReportView: "classStudentAttendanceReportView",
  studentAttendanceReportView: "studentAttendanceReportView",
  staffAttendanceReportView: "staffAttendanceReportView",
  classScoreUpload: "classScoreUpload",
  scoreUpload: "scoreUpload",
  downloadScore: "downloadScore",
  timetableManage: "timetableManage",
  progressionManage: "progressionManage",
  userManage: "userManage",
  studentDocsExport: "studentDocsExport",
  staffDocsExport: "staffDocsExport",
};

export const hasPermission = (currentUser, permissionKey) => {
  if (!permissionKey) return true;
  if (!currentUser) return false;
  if (currentUser.role === "admin") return true;
  if (currentUser.role === "appOwner") return true;

  const permissions = currentUser.permissions || {};
  const requiredPermissions = Array.isArray(permissionKey)
    ? permissionKey
    : [permissionKey];
  return requiredPermissions.some((key) => Boolean(permissions[key]));
};
